module.exports = __webpack_public_path__ + "static/media/wMEMO.3f8f5cc9.png";